import Vue from 'vue'
import Vuex from 'vuex'
import DashboardModule from '@/store/modules/dashboard';
import OnboardModule from '@/store/modules/onboard';
import ProductsModule from '@/store/modules/products';
import CustomersModule from '@/store/modules/customers';
import OrdersModule from '@/store/modules/orders';
import SalesAgentModule from '@/store/modules/salesAgent';
import PaymentSlipModule from '@/store/modules/paymentSlip';
import PreShipmentsModule from '@/store/modules/preShipments';
import UtilModule from '@/store/modules/util';
import WalletModule from '@/store/modules/wallet';
import NotificationModule from '@/store/modules/notifications';
import MessengerModule from '@/store/modules/messenger';
import BroadcastModule from '@/store/modules/broadcast';

import ShopsModule from '@/store/modules/shops';
import SettingsModule from '@/store/modules/settings';
import UserModule from '@/store/modules/user';
import BotPagesModule from '@/store/modules/botPages';
import TrackingPagesModule from '@/store/modules/trackingPages';
import TiktokSofModule from '@/store/modules/tiktokSof';
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({ storage: window.localStorage })

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    dashboard: DashboardModule,
    products: ProductsModule,
    customers: CustomersModule,
    orders: OrdersModule,
    preShipments: PreShipmentsModule,
    onboard: OnboardModule,
    user: UserModule,
    salesAgent: SalesAgentModule,
    paymentSlip: PaymentSlipModule,
    util: UtilModule,
    wallet: WalletModule,
    notifications: NotificationModule,
    messenger: MessengerModule,
    broadcast: BroadcastModule,

    settings: SettingsModule,
    shops: ShopsModule,
    botPages: BotPagesModule,
    trackingPages: TrackingPagesModule,
    tiktokSof: TiktokSofModule
  },
  plugins: [vuexLocal.plugin]
})


